// /* ============================================================
//    WorldFillBlankWordBankInline.jsx
//    ============================================================ */

// export default function WorldFillBlankWordBankInline({
//   value = {},
//   onChange,
//   questions,
//   bank,
//   mode = "edit",
//   feedback
// }) {
//   function setAnswer(id, v) {
//     if (mode !== "edit") return;
//     onChange({
//       ...value,
//       [id]: v
//     });
//   }

//   const WORD_BANK = bank;
//   const QUESTIONS = questions;
//   const isReview = mode === "review";

//   return (
//     <div style={{ display: "grid", gap: 24 }}>
//       {/* ───────── WORD BANK ───────── */}
//       <div
//         style={{
//           border: "1px solid #ccc",
//           borderRadius: 8,
//           padding: 12
//         }}
//       >
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
//             gap: 4,
//             fontSize: 14
//           }}
//         >
//           {WORD_BANK.map((w) => (
//             <div key={w}>{w}</div>
//           ))}
//         </div>
//       </div>

//       {/* ───────── QUESTIONS ───────── */}
//       <div style={{ display: "grid", gap: 14 }}>
//         {QUESTIONS.map((q, i) => {
//           const fb = feedback?.parts?.[q.id];

//           const border =
//             !isReview
//               ? "1px solid #aaa"
//               : fb?.correct
//               ? "2px solid #2e7d32"
//               : "2px solid #c62828";

//           return (
//             <div key={q.id} style={{ lineHeight: 1.8 }}>
//               <strong>{i + 1}.</strong>{" "}
//               {q.before}
//               <input
//                 type="text"
//                 value={value[q.id] || ""}
//                 disabled={isReview}
//                 onChange={(e) => setAnswer(q.id, e.target.value)}
//                 style={{
//                   width: q.width,
//                   margin: "0 6px",
//                   padding: "2px 4px",
//                   border,
//                   borderRadius: 4
//                 }}
//               />
//               {q.after}

//               {/* Optional expected answer display */}
//               {isReview && !fb?.correct && fb?.expected != null && (
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "#c62828",
//                     marginLeft: 24
//                   }}
//                 >
//                   Correct answer: <strong>{fb.expected}</strong>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";

/* ============================================================
   WorldFillBlankWordBankInline (Drag & Drop Version)
   ============================================================ */

export default function WorldFillBlankWordBankInline({
  value = {},
  onChange,
  questions,
  bank,
  mode = "edit",
  feedback
}) {
  const [dragging, setDragging] = useState(null);
  const [hovered, setHovered] = useState(null);

  const isReview = mode === "review";

  function setAnswer(id, v) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      [id]: v
    });
  }

  function removeWord(wordId) {
    if (mode !== "edit") return;

    const next = { ...value };
    next[wordId] = "";
    onChange(next);
  }

  const usedWords = Object.values(value);

  return (
    <div style={{ display: "grid", gap: 24 }}>
      {/* ───────── WORD BANK ───────── */}
      <div
        style={{
          border: "2px solid #ccc",
          borderRadius: 8,
          padding: 12
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 6,
            fontSize: 14
          }}
        >
          {bank.map((w) => {
            const alreadyUsed = usedWords.includes(w);

            return (
              <div
                key={w}
                draggable={!alreadyUsed && mode === "edit"}
                onDragStart={() => setDragging(w)}
                style={{
                  padding: "6px 8px",
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  background: alreadyUsed ? "#ddd" : "#f3f3f3",
                  opacity: alreadyUsed ? 0.5 : 1,
                  cursor:
                    alreadyUsed || isReview ? "default" : "grab",
                  userSelect: "none"
                }}
              >
                {w}
              </div>
            );
          })}
        </div>
      </div>

      {/* ───────── QUESTIONS ───────── */}
      <div style={{ display: "grid", gap: 14 }}>
        {questions.map((q, i) => {
          const fb = feedback?.parts?.[q.id];
          const current = value[q.id] || "";

          return (
            <div key={q.id} style={{ lineHeight: 1.8 }}>
              <strong>{i + 1}.</strong>{" "}
              {q.before}

              {/* DROP ZONE */}
              <span
                onDragOver={(e) => {
                  if (!dragging) return;
                  e.preventDefault();
                  setHovered(q.id);
                }}
                onDragLeave={() => setHovered(null)}
                onDrop={() => {
                  if (!dragging) return;

                  const next = { ...value };
                  Object.keys(next).forEach((k) => {
                    if (next[k] === dragging) next[k] = "";
                  });

                  next[q.id] = dragging;
                  onChange(next);

                  setDragging(null);
                  setHovered(null);
                }}
                onClick={() => {
                  if (!current || isReview) return;
                  removeWord(q.id);
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minWidth: q.width || 100,
                  height: 28,
                  padding: "0 8px",
                  margin: "0 6px",
                  borderRadius: 6,

                  // ✅ BORDER LOGIC
                  border:
                    !isReview
                      ? "2px solid #aaa"
                      : fb?.correct
                      ? "2px solid #2e7d32"
                      : "2px solid #c62828",

                  // optional light background tint
                  background:
                    !isReview
                      ? current
                        ? "#f9f9f9"
                        : "#fff"
                      : fb?.correct
                      ? "#e8f5e9"
                      : "#ffebee",

                  boxShadow:
                    hovered === q.id && !isReview
                      ? "0 0 0 2px #1976d2"
                      : "none",

                  cursor:
                    current && !isReview ? "pointer" : "default",

                  transition: "all 0.15s ease"
                }}
              >
                <span>{current || "Drop here"}</span>

                {current && !isReview && (
                  <span
                    style={{
                      fontWeight: 700,
                      color: "#999",
                      marginLeft: 6
                    }}
                  >
                    ×
                  </span>
                )}
              </span>

              {q.after}

              {/* Review Feedback */}
              {/* {isReview && !fb?.correct && fb?.expected != null && (
                <div
                  style={{
                    fontSize: 12,
                    color: "#c62828",
                    marginLeft: 24
                  }}
                >
                  Correct answer: <strong>{fb.expected}</strong>
                </div>
              )} */}
            </div>
          );
        })}
      </div>
    </div>
  );
}